module.exports = __webpack_public_path__ + "img/用水明细.ac21eedd.png";